const initTestimonialsSlider = () => {
  document.querySelectorAll('.testimonials-slider').forEach(slider => {
    const { cardId } = slider.dataset;

    new Swiper(slider, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      loop: false,
      pagination: {
        el: `.swiper-pagination--${cardId}`,
        clickable: true
      }
    });
  });
};

initTestimonialsSlider();
